// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"94511a96","787":"a3b827dc"}[chunkId] + ".chunk.js";
};